import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../services/api';

const UpdateSubPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();  
  const [pages, setPages] = useState([]);
  const [subPageName, setSubPageName] = useState('');
  const [selectedPage, setSelectedPage] = useState('');

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const response = await api.get('/pages');
        setPages(response.data);
      } catch (error) {
        console.error('Error fetching pages:', error);
        alert('Failed to fetch pages');
      }
    };

    fetchPages();
  }, []);

  useEffect(() => {
    const fetchSubpageData = async () => {
      try {
        const response = await api.get(`/subpages/${id}`);
        setSubPageName(response.data.subpage);
        setSelectedPage(response.data.page.id); 
      } catch (error) {
        console.error('Error fetching subpage data:', error);
        alert('Failed to fetch subpage data');
      }
    };

    fetchSubpageData();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('pageId', selectedPage);
    formData.append('subpageName', subPageName);

    try {
      const response = await api.put(`/subpages/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.status === 200) {
        alert(`Subpage updated successfully!`);
        navigate('/manage-subpage');
      } else {
        alert('Failed to update subpage. Please try again.');
      }
    } catch (error) {
      console.error('Error updating subpage:', error);
      alert('Error updating subpage');
    }
  };

  const handleCancel = () => {
    navigate('/manage-subpage');
  };

  return (
    <div className='container mt-5'>
      <form onSubmit={handleSubmit}>
        <div className="col-sm-6">
          <div>
            <label className="mb-1">Select Page</label>
            <select
              className="form-control mb-3"
              value={selectedPage}
              onChange={(e) => setSelectedPage(e.target.value)}
            >
              <option value="">Select Page</option>
              {pages.map((page) => (
                <option key={page.id} value={page.id}>
                  {page.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="mb-1">Enter Subpage Name</label>
            <input
              type="text"
              className="form-control mb-3"
              value={subPageName}
              onChange={(e) => setSubPageName(e.target.value)} 
            />
          </div>

          <div className="button-group">
            <button type="submit" className="btn btn-success submit-button">Update</button>
            <button type="button" className="btn btn-danger cancel-button" onClick={handleCancel}>Cancel</button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UpdateSubPage;
